import React from "react";
import "./Header.css";

const Header = ({ isOfferPage, currentStep, imageUrl }) => {
  isOfferPage = true;

  const logoSrc = isOfferPage
    ? "/assets/img/New_LOGO.svg"
    : "/assets/img/newLogo.png";

  // ✅ dynamic Tailwind for header layout
  const headerClass = imageUrl && currentStep < 4
    ? "w-full flex justify-between items-center px-4 py-2"
    : "w-full flex justify-center items-center px-4 py-2";

  return (
    <header className={headerClass}>
      <img src={logoSrc} alt="Digit Money Logo" className="logo-img" />

      {currentStep < 4  && imageUrl && (
        <img
          src={imageUrl}
          alt="Aditya Birla Finance Logo"
          className="logo-img-abc"
        />
      )}
    </header>
  );
};

export default Header;
